export default {"src":"https://s.sylndr.com/c-1ab3f05/_next/static/media/booking-arrow-up.c54f10c8.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};